import React from "react";
import { useSelector } from "react-redux";
import { selectors } from "@Src/redux/reducers";
import Theme from "@accessdev/arc-ui-react/Theme";

const ArcTheme = ({ children }) => {
  const programColor = useSelector(selectors.getProgramColor);
  return <Theme customTheme={{ program_color: programColor }}>{children}</Theme>;
};

export default ArcTheme;
